interface Props {
  fields: any;
  renderBlocks: (block: any, index: number) => React.ReactNode;
}

const AccordionFields = ({ fields, renderBlocks }: Props) => (
  <>{fields.map(renderBlocks)}</>
);

export default AccordionFields;
